import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';

export default function AdminDashboard() {
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const buscarEstatisticas = async () => {
      setLoading(true);
      
      // Busca a contagem de cada tabela
      const countTable = async (tableName) => {
        const { count, error } = await supabase
          .from(tableName)
          .select('*', { count: 'exact', head: true });
        return error ? 0 : count;
      };

      const [fss, cras1, cras2, creas] = await Promise.all([
        countTable('concessoes'),
        countTable('cras1_atendimentos'),
        countTable('cras2_atendimentos'),
        countTable('creas_atendimentos')
      ]);

      setDadosGrafico([
        { name: 'Fundo Social', total: fss, color: '#1e3a8a' }, // Azul
        { name: 'CRAS I', total: cras1, color: '#15803d' },      // Verde
        { name: 'CRAS II', total: cras2, color: '#059669' },     // Esmeralda
        { name: 'CREAS', total: creas, color: '#b91c1c' },       // Vermelho
      ]);
      setLoading(false);
    };

    buscarEstatisticas();
  }, []);

  if (loading) return <div className="p-20 text-center font-black text-gray-400 animate-pulse">GERANDO RELATÓRIO CONSOLIDADO...</div>;

  return (
    <div className="space-y-8">
      <header>
        <h2 className="text-3xl font-black text-gray-800 uppercase tracking-tighter">📊 Painel de Gestão Municipal</h2>
        <p className="text-sm font-bold text-gray-400 uppercase">Consolidado de Atendimentos - Mirassol/SP</p>
      </header>

      {/* CARDS DE RESUMO */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {dadosGrafico.map((item) => (
          <div key={item.name} className="bg-white p-6 rounded-3xl border border-gray-100 shadow-xl">
            <p className="text-[10px] font-black text-gray-400 uppercase mb-1">{item.name}</p>
            <p className="text-4xl font-black text-gray-800">{item.total}</p>
            <p className="text-[9px] font-bold text-gray-400 mt-2 uppercase">Atendimentos Totais</p>
          </div>
        ))}
      </div>

      {/* GRÁFICO COMPARATIVO */}
      <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl border border-gray-100">
        <h3 className="text-lg font-black text-gray-800 uppercase mb-8">Comparativo por Unidade</h3>
        <div className="h-80 w-full">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={dadosGrafico}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fontSize: 10, fontWeight: 'bold'}} />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip cursor={{fill: '#f3f4f6'}} contentStyle={{borderRadius: '15px', border: 'none', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)'}} />
              <Bar dataKey="total" radius={[10, 10, 0, 0]} barSize={60}>
                {dadosGrafico.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
